/* eslint-disable */
import Api from '@/api/services/Api'

const route = '/adm-task'

export default {
    get: params => {
        let customRoute = `${route}?user=${params.currentUser}&estado=1&expand=tipoTarea,creadaPor,status_description&search=${params.filter}`
        switch (params.tareaEstado) {
            case "2": customRoute = `${route}?user=${params.currentUser}&estado=1&cumplida=2&expand=tipoTarea,creadaPor,status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?user=${params.currentUser}&estado=1&cumplida=1&expand=tipoTarea,creadaPor,status_description&search=${params.filter}`
                break;
            case "5": customRoute = `${route}?user=${params.currentUser}&${params.customfilter}&estado=1&expand=tipoTarea,creadaPor,status_description&search=${params.filter}`//tareas del dia
                break;
            case "6": customRoute = `${route}?user=${params.currentUser}&${params.customfilter}&estado=1&expand=tipoTarea,creadaPor,status_description&search=${params.filter}`
                break;
            case "7": customRoute = `${route}?user=${params.currentUser}&${params.customfilter}&estado=1&expand=tipoTarea,creadaPor,status_description&search=${params.filter}`//tareas con fecha de cumplimiento en el dia
                break;
            case "8": customRoute = `${route}?user=${params.currentUser}&${params.customfilter}&estado=1&expand=tipoTarea,creadaPor,status_description&search=${params.filter}`//tareas cumplidas en el dia
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    toogle_status: payload => Api().put(`/adm-task-user/${payload.id}`)
}
